import { createHttpEndpoint } from '../../utils'

import type { BuyBackProducts } from './buyback-products.types'

/**
 * List the buyback products
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/catalog-buyback-api/definition#tag/Buyback-products/operation/get-bm-catalog-buyback-bo-admin-merchants-merchantid-products}
 */
export const getBuyBackProducts = createHttpEndpoint<BuyBackProducts>({
  method: 'GET',
  operationId: 'getBuyBackProducts',
  path: '/bm/catalog/buyback/bo-seller/products/search',
})
